import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import ProjectsPage from "./ui/projects-page";

export const ProjectsPageRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.projects()}`,
    element: createElement(ProjectsPage),
    children: [...rest],
  };
};

export { ProjectPageSkeleton } from "./ui/project-skeleton";
